import { render, staticRenderFns } from "./ModalCallback.vue?vue&type=template&id=47ecd2d6&"
import script from "./ModalCallback.vue?vue&type=script&lang=js&"
export * from "./ModalCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports